import React, { useContext, useEffect, useState } from "react";
import { PhotographyContext } from "contexts/photography";
import { ShotContext } from "../context";
import { Select } from "components/form-inputs/inputs";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/free-solid-svg-icons";

const Gs1DropDowns = (props) => {
    const { lookups } = useContext(PhotographyContext);
    const { photo, wipKey, closeModal, savedCodes, isIE, changeIEGs1 } = props;
    // TODO: FIX!!!
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const { updateGs1Code } = !isIE && useContext(ShotContext);

    const [codes, setCodes] = useState({
        imageType: null,
        imageFacing: null,
        imageAngle: null,
        imageState: null,
    });

    useEffect(() => {
        if (savedCodes) {
            setCodes({
                imageType: savedCodes.imageType && savedCodes.imageType.value,
                imageFacing: savedCodes.imageFacing && savedCodes.imageFacing.value,
                imageAngle: savedCodes.imageAngle && savedCodes.imageAngle.value,
                imageState: savedCodes.imageState && savedCodes.imageState.value,
            });
        }
    }, [savedCodes]);

    const saveOptions = () => {
        Object.keys(codes).forEach((key) => {
            codes[key] = parseInt(codes[key]);

            return (codes[key] = !codes[key] ? null : codes[key]);
        });
        closeModal();

        if (!isIE) {
            return updateGs1Code(codes, photo.key);
        } else {
            return changeIEGs1(codes, photo.key);
        }
    };

    return (
        <div>
            <h2>GS1 Code</h2>
            <div className="row">
                <div className="gs1-image">
                    {photo && (
                        <>
                            <div className="image-block">
                                <img
                                    id={`img_${wipKey}_${photo.key}`}
                                    onMouseDown={(e) => {
                                        e.preventDefault();
                                    }}
                                    alt={`Product ${photo.imageViewDescription || "Coding"}`}
                                    src={photo.uneditedImageUris ? `${photo.uneditedImageUris.medium}?v=${photo.timestamp}` : ""}
                                />
                            </div>

                            <h4>
                                {photo.imageViewDescription} {photo.isDefaultImageView ? " (Ecom)" : ""}
                                {photo.isPremiumEditing && (
                                    <div className="premium-star">
                                        <FontAwesomeIcon icon={faStar} />
                                    </div>
                                )}
                            </h4>
                        </>
                    )}
                </div>
                <div
                    style={{
                        marginLeft: "2em",
                    }}
                >
                    <div className="gs1-dropdowns">
                        <Select
                            label="Image Type"
                            name="imageType"
                            onChange={(event) => setCodes({ ...codes, imageType: event.target.value })}
                            value={codes.imageType}
                            options={lookups.imageTypeOptions}
                        />
                        <Select
                            label="Image Facing"
                            name="imageFacing"
                            onChange={(event) => setCodes({ ...codes, imageFacing: event.target.value })}
                            value={codes.imageFacing}
                            options={lookups.imageFacingOptions}
                        />
                        <Select
                            label="Image Angle"
                            name="imageAngle"
                            onChange={(event) => setCodes({ ...codes, imageAngle: event.target.value })}
                            value={codes.imageAngle}
                            options={lookups.imageAngleOptions}
                        />
                        <Select
                            label="Image State"
                            name="imageState"
                            onChange={(event) => setCodes({ ...codes, imageState: event.target.value })}
                            value={codes.imageState}
                            options={lookups.imageStateOptions}
                        />
                    </div>
                    <div className="justify-content-center">
                        <button className="button" onClick={closeModal}>
                            Cancel
                        </button>
                        <button
                            className="button -primary"
                            onClick={saveOptions}
                            style={{
                                marginLeft: "2em",
                            }}
                        >
                            Upload
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Gs1DropDowns;
